var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canCheckout)?_c('BaseButton',{attrs:{"label":_vm.$t('common.button.checkout'),"icon-placement":"right","variant":_vm.variant,"size":_vm.size,"loading":_vm.loading},on:{"click":_vm.checkout}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }